import { render, staticRenderFns } from "./ViewAgreement.vue?vue&type=template&id=e06e265e&scoped=true"
import script from "./ViewAgreement.vue?vue&type=script&lang=js"
export * from "./ViewAgreement.vue?vue&type=script&lang=js"
import style0 from "./ViewAgreement.vue?vue&type=style&index=0&id=e06e265e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06e265e",
  null
  
)

export default component.exports